import { render } from "./CobaltProfilesList.vue?vue&type=template&id=4c67f5d8"
import script from "./CobaltProfilesList.vue?vue&type=script&lang=js"
export * from "./CobaltProfilesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__